import { EmptyState, PageHeader, Skeleton } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { PollBuilder } from '@/features/polls/PollBuilder';
import { usePoll } from '@/features/polls/hooks';
import { useNavigate, useParams } from '@solidjs/router';
import { Show } from 'solid-js';

const EditDraft = (props: { id: string }) => {
  const query = usePoll(() => props.id);
  const navigate = useNavigate();
  return (
    <Show when={!query.isPending} fallback={<Skeleton class="m-6 h-64" />}>
      <Show
        when={query.data?.data}
        fallback={<EmptyState variant="error" title="Poll not found" />}
      >
        {(poll) => (
          <Show
            when={poll().canManage && poll().status === 'draft'}
            fallback={<EmptyState title="This poll cannot be edited" />}
          >
            <PollBuilder
              poll={poll()}
              onClose={() => navigate('/polls')}
              onSaved={(id) => navigate(`/polls/${id}`)}
            />
          </Show>
        )}
      </Show>
    </Show>
  );
};

export default function PollEditor() {
  const params = useParams<{ pollId: string }>();
  const { session } = useAuth();
  const navigate = useNavigate();
  return (
    <Show when={session()}>
      <Show
        when={params.pollId}
        keyed
        fallback={
          <Show
            when={session()?.permissions.has('polls:create')}
            fallback={
              <>
                <PageHeader title="New Poll" />
                <EmptyState title="You do not have permission to create polls" />
              </>
            }
          >
            <PollBuilder
              onClose={() => navigate('/polls')}
              onSaved={(id) => navigate(`/polls/${id}`)}
            />
          </Show>
        }
      >
        {(id) => <EditDraft id={id} />}
      </Show>
    </Show>
  );
}
